import { Pagination } from '@shared/components/data-table/datatable.model';

export const TEXT_BUTTON = {
    OK: 'Ok',
    CANCEL: 'Cancelar',
};

export const PAGINATOR_OPTS = {
    TOTAL_COUNT: 0,
    PAGE_INDEX: 0,
    PAGE_SIZE: 10,
    PAGE_SIZE_OPT: [5, 10, 25],
};

// actions
export enum ACTIONS {
    CREATE = 'create',
    UPDATE = 'update',
    PREVIEW = 'preview',
    FETCH = 'fetch',
    CLONE = 'clone',
    ACTIVATE = 'activate',
    DEACTIVATE = 'deactivate',
    DELETE = 'delete',
    MANAGEMENT = 'management',
    MANAGEMENT2 = 'management2',
    SHOW = 'show',
    HISTORY = 'history',
    TOGGLE = 'toggle',
    SHUTDOWN = 'shutdown',
    SHOWTRANSACTION = 'showTransaction',
    RETRY = 'retry',
    CHARGE = 'charge',
    DOWNLOAD = 'download',
    PAY = 'pay',
    UPLOAD = 'upload',
}

// mat icon
export enum MAT_ICON {
    ACTIONS = 'more_horiz',
    PREVIEW = 'visibility',
    PREVIEW_OFF = 'visibility_off',
    UPDATE = 'create',
    CLONE = 'file_copy',
    ACTIVATE = 'offline_pin',
    DEACTIVATE = 'restore_from_trash',
    DELETE = 'delete',
    WARN = 'warning',
    CLOSE = 'close',
    ERROR = 'error_outline',
    USER = 'account_circle',
    PASSWORD = 'lock',
    CHECK = 'check_circle_outline',
    MANAGEMENT = 'build',
    DOWNLOAD = 'download',
    DEACTIVATE_TEXT = 'Inactivar',
    ACTIVATE_TEXT = 'Activar',
    KEY = 'key',
    PERCENTAGE = 'percent',
    CALCULATE = 'calculate',
    CREDIT_CARD = 'credit_card',
    TAG = 'tag',
    DESCRIPTION = 'description',
    TRANSACTION = 'paid',
    RETRY_PAY = 'currency_exchange',
    PAYMENT = 'payments',
    UPLOAD = 'upload_file',
    ARROWPATH = 'autorenew',
    TRENDINGUP = 'trending_up',
}

export enum TYPE_MESSAGE {
    SUCCESS = 'success',
    WARN = 'warn',
    ERROR = 'error',
}

export const HERO_ICONS = 'heroicons_solid:';
export const OUTLINE_ICONS = 'heroicons_outline:';

export const MAT_SVG_ICON = {
    /* SOLID ICONS */
    ADD: `${HERO_ICONS}plus-circle`,
    PLUS_ADD: `${HERO_ICONS}plus`,
    DELETE: `${HERO_ICONS}trash`,
    MAIL: `${HERO_ICONS}envelope`,
    PHONE: `${HERO_ICONS}phone`,
    EYE: `${HERO_ICONS}eye`,
    EYE_OFF: `${HERO_ICONS}eye-slash`,
    ERROR: `${HERO_ICONS}exclamation-circle`,
    USER: `${HERO_ICONS}user`,
    X_CIRCLE: `${HERO_ICONS}x-circle`,
    CLOSE: `${HERO_ICONS}x-mark`,
    ID: `${HERO_ICONS}identification`,
    SERVER: `${HERO_ICONS}server`,
    PLUS: `${HERO_ICONS}plus`,
    ROOM: `${HERO_ICONS}office-building`,
    BED: `${HERO_ICONS}home`,
    CALENDAR: `${HERO_ICONS}calendar`,
    DESCRIPTION: `${HERO_ICONS}document-text`,
    SEARCH: `${HERO_ICONS}search`,
    DATE: `${HERO_ICONS}cake`,
    TRASH: `${HERO_ICONS}trash`,
    CAMERA: `${HERO_ICONS}camera`,
    MORE: `${HERO_ICONS}ellipsis-vertical`,
    TRENDING: `${HERO_ICONS}arrow-trending-down`,
    EXPORT: `${HERO_ICONS}arrow-up-circle`,
    REFUND: `${HERO_ICONS}arrow-uturn-left`,
    PAY: `${HERO_ICONS}currency-dollar`,
    KEY: `${HERO_ICONS}key`,
    CALCULATE: `${HERO_ICONS}calculator`,
    LINK: `${HERO_ICONS}link`,
    CARD: `${HERO_ICONS}credit-card`,
    TAG: `${HERO_ICONS}tag`,
    PORTAL: `${HERO_ICONS}globe-americas`,
    COMPANY: `${HERO_ICONS}briefcase`,
    OFFICE: `${HERO_ICONS}building-office`,
    LOCATION: `${HERO_ICONS}map-pin`,
    BILLING: `${HERO_ICONS}banknotes`,
    PERCENTAGE: `${HERO_ICONS}receipt-percent`,
    CALENDAR_DAY: `${HERO_ICONS}calendar-days`,
    ARROW_UP: `${HERO_ICONS}bars-arrow-up`,
    ARROW_DOWN: `${HERO_ICONS}bars-arrow-down`,
    LEFT: `${HERO_ICONS}chevron-left`,
    RIGHT: `${HERO_ICONS}chevron-right`,

    /* OUTLINE ICONS */
    EYE_OUTLINE: `${OUTLINE_ICONS}eye`,
    QR_OUTLINE: `${OUTLINE_ICONS}qr-code`,
    EDIT_OUTLINE: `${OUTLINE_ICONS}pencil`,
    EXPORT_OUTLINE: `${OUTLINE_ICONS}arrow-up-circle`,
    ADD_OUTLINE: `${OUTLINE_ICONS}plus-circle`,
    LINK_OUTLINE: `${OUTLINE_ICONS}link`,
    BACK_OUTLINE: `${OUTLINE_ICONS}chevron-left`,
    NEXT_OUTLINE: `${OUTLINE_ICONS}chevron-right`,
    CASH_OUTLINE: `${OUTLINE_ICONS}banknotes`,
    WALLET_OUTLINE: `${OUTLINE_ICONS}wallet`,
    UPLOAD_OUTLINE: `${OUTLINE_ICONS}cloud-arrow-up`,
    PHONE_OUTLINE: `${OUTLINE_ICONS}phone`,
    MAIL_OUTLINE: `${OUTLINE_ICONS}envelope`,
    KEY_OUTLINE: `${OUTLINE_ICONS}key`,
    DESCRIPTION_OUTLINE: `${OUTLINE_ICONS}document-text`,
    TAG_OUTLINE: `${OUTLINE_ICONS}tag`,
    ERROR_OUTLINE: `${OUTLINE_ICONS}exclamation-circle`,
    WARNING: `${OUTLINE_ICONS}exclamation-triangle`,
    USER_CIRCLE: `${OUTLINE_ICONS}user-circle`,
    CHECK_CIRCLE: `${OUTLINE_ICONS}check-circle`,
    CHECK_OUTLINE: `${OUTLINE_ICONS}check`,
    SIGN_OUT: `${OUTLINE_ICONS}arrow-right-circle`,
    SECURITY: `${OUTLINE_ICONS}lock-closed`,
    ORIGIN: `${OUTLINE_ICONS}rectangle-group`,
    TREND: `${OUTLINE_ICONS}arrow-trending-up`,
    VIRTUAL_TERMINAL: `${OUTLINE_ICONS}cursor-arrow-rays`,
    ALTERNATIVE: `${OUTLINE_ICONS}currency-dollar`,
    RESERVATION: `${OUTLINE_ICONS}bookmark-square`,
    CURRENCY: `${OUTLINE_ICONS}currency-dollar`,
    CLIPBOARD: `${OUTLINE_ICONS}clipboard-document-list`,
    USER_GROUP: `${OUTLINE_ICONS}user-group`,
    COMPANY_OUTLINE: `${OUTLINE_ICONS}briefcase`,
    BUILDING_OUTLINE: `${OUTLINE_ICONS}building-library`,
    OFFICE_OUTLINE: `${OUTLINE_ICONS}building-office`,
    PORTAL_OUTLINE: `${OUTLINE_ICONS}globe-americas`,
    USER_OUTLINE: `${OUTLINE_ICONS}user`,
    ROLES_OUTLINE: `${OUTLINE_ICONS}arrow-left-on-rectangle`,
    SHIELD: `${OUTLINE_ICONS}shield-check`,
    QUESTION: `${OUTLINE_ICONS}question-mark-circle`,
    COPY: `${OUTLINE_ICONS}document-duplicate`,
    SCALE: `${OUTLINE_ICONS}scale`,
    CARD_OUTLINE: `${OUTLINE_ICONS}credit-card`,
    BILLING_OUTLINE: `${OUTLINE_ICONS}banknotes`,
    INFO: `${OUTLINE_ICONS}information-circle`,
    RECHARGE_OUTLINE: `${OUTLINE_ICONS}arrow-trending-up`,
};

// toggle name
export enum STATUS_TOGGLE {
    ENABLE = 'Activo',
    DISABLE = 'Inactivo',
    ENABLED = 'Activado',
    DISABLED = 'Desactivado',
}

// actions
export enum ACTIONS_BUTTON {
    UPDATE = 'update',
    PREVIEW = 'preview',
    ACTIVATE = 'activate',
    DEACTIVATE = 'deactivate',
    DELETE = 'delete',
}

export const OPTIONS_OBJECT = {
    [ACTIONS_BUTTON.UPDATE]: {
        name: 'update',
        label: 'Editar',
        icon: MAT_ICON.UPDATE,
        action: ACTIONS.UPDATE,
        rol: ['ADMIN_ROLE'],
    },
    [ACTIONS_BUTTON.PREVIEW]: {
        name: 'preview',
        label: 'Detalles',
        icon: MAT_ICON.PREVIEW,
        action: ACTIONS.PREVIEW,
        rol: ['ADMIN_ROLE'],
    },
    [ACTIONS_BUTTON.ACTIVATE]: {
        name: 'activate',
        label: 'Activar',
        icon: MAT_ICON.ACTIVATE,
        action: ACTIONS.ACTIVATE,
    },
    [ACTIONS_BUTTON.DEACTIVATE]: {
        name: 'deactivate',
        label: 'Desactivar',
        icon: MAT_ICON.DEACTIVATE,
        action: ACTIONS.DEACTIVATE,
    },
    [ACTIONS_BUTTON.DELETE]: {
        name: 'delete',
        label: 'Eliminar',
        icon: MAT_ICON.DELETE,
        action: ACTIONS.DELETE,
    },
};

export const HTTP_PARAMS_SCROLL = {
    offset: '0',
    limit: '20',
};
export const HTTP_PARAMS_ALL = {
    offset: '0',
    limit: '100',
};

export enum FILTERS_LABEL {
    FILTERS = 'filters',
    SORTERS = 'sorters',
    LIMIT = 'limit',
    OFFSET = 'offset',
    IS_ARCHIVED = 'is_archived',
    EXTERNAL = 'external',
    FIREWALL = 'firewall',
}

export enum LOADING_STATE {
    LOADING = 'LOADING',
    NO_DATA = 'no-data',
    ERROR = 'error',
    FINISHED = 'FINISH',
}

export const genderType = [
    {
        id: 0,
        name: 'Hombre',
    },
    {
        id: 1,
        name: 'Mujer',
    },
    {
        id: 2,
        name: 'Personalizado',
    },
];
export const pronType = [
    {
        id: 0,
        name: 'Masculino',
    },
    {
        id: 1,
        name: 'Femenino',
    },
    {
        id: 2,
        name: 'Neutro',
    },
];

export type CRITERIAS_TYPE = {
    name: string;
    key: string;
    tip: string;
    management?: boolean;
    icon?: string;
};
export const CRITERIAS_POLICY: CRITERIAS_TYPE[] = [
    {
        name: 'Escenario',
        key: 'scenarios',
        tip: 'Indica escenario en donde se aplica la política, ej: cobro standar, no-show o cancelación.',
        management: false,
        icon: MAT_SVG_ICON.COMPANY,
    },
    {
        name: 'Noches a cobrar',
        key: 'charge_nights',
        tip: 'Indica el número de noches a cobrar.',
        management: true,
        icon: MAT_SVG_ICON.CURRENCY,
    },
    {
        name: 'Momento',
        key: 'timeframes',
        tip: 'Horas a tener en cuenta a partir de la fecha indicada para realizar el cobro, ej: 24hrs o 48hrs.',
        management: true,
        icon: MAT_SVG_ICON.CALENDAR,
    },
    {
        name: 'M. tiempo',
        key: 'timings',
        tip: 'Marco de tiempo: determina el tiempo para aplicar cobro ej: antes, después o igual a una fecha determinada.',
        management: false,
        icon: MAT_SVG_ICON.VIRTUAL_TERMINAL,
    },
    {
        name: 'F. referencia',
        key: 'ref_dates',
        tip: 'fecha de referencia: indica la fecha a utilizar para el cobro.',
        management: false,
        icon: MAT_SVG_ICON.CARD,
    },
    {
        name: 'Cuotas',
        key: 'installments',
        tip: 'Indica el número de cuotas a cobrar',
        management: true,
        icon: MAT_SVG_ICON.CALCULATE,
    },
];

export enum SPINNER_STATE {
    SHOW = 'LOADING',
    HIDE = 'FINISHED',
    DONE = 'DONE',
    CHECKED = 'CHECKED',
    FAILED = 'FAILED',
    NOTHING = 'NODATA',
}

export const hotels = [
    {
        id: '13645',
        name: 'Hotel Azuan Suites',
    },
    {
        id: '13644',
        name: 'Hotel Avexi Suites',
    },
    {
        id: '13643',
        name: 'Hotel Marina Suites',
    },
    {
        id: '14364',
        name: 'Bocagrande Cartagena',
    },
    {
        id: '13633',
        name: 'Hotel Aixo Suites',
    },
    {
        id: '17491',
        name: 'Hotel Rodadero Inn',
    },
    {
        id: '16255',
        name: 'Madisson Inn Hotel & Luxury Suites',
    },
    {
        id: '15736',
        name: 'Hotel 1525 By Gh Suites',
    },
    {
        id: '17644',
        name: 'Hotel Abi Inn',
    },
    {
        id: '18004',
        name: 'MT Hotel Windsor House Inn By GEH Suites',
    },
];

export const STATUS_LIST = [
    {
        id: '0',
        name: 'Pendiente',
        class: 'bg-blue-200/30',
        text: 'text-blue-700',
    },
    {
        id: '1',
        name: 'Checkin',
        class: 'bg-green-200/30',
        text: 'text-green-700',
    },
    {
        id: '2',
        name: 'No-Show',
        class: 'bg-gray-100/30',
        text: 'text-gray-700',
    },
    {
        id: '3',
        name: 'Cancelado',
        class: 'bg-red-200/30',
        text: 'text-red-700',
    },
    {
        id: '4',
        name: 'Salida anticipada',
        class: 'bg-gray-300/30',
        text: 'text-gray-700',
    },
    {
        id: '6',
        name: 'Cobro automático cancelado',
        class: 'bg-pink-500/30',
        text: 'text-pink-700',
    },
];
export const STATUS_LIST_OBJ = {
    '0': {
        name: 'Pendiente',
        code: '0',
        class: 'bg-blue-200/30',
        text: 'text-blue-700',
    },
    '1': {
        name: 'Checkin',
        code: '1',
        class: 'bg-green-200/30',
        text: 'text-green-700',
    },
    '2': {
        name: 'No-Show',
        code: '2',
        class: 'bg-gray-100/30',
        text: 'text-gray-400',
    },
    '3': {
        name: 'Cancelado',
        code: '3',
        class: 'bg-red-200/30',
        text: 'text-red-700',
    },
    '4': {
        name: 'Salida anticipada',
        code: '4',
        class: 'bg-gray-300/30',
        text: 'text-gray-500',
    },
    '5': {
        name: 'Reembolso',
        code: '5',
        class: 'bg-yellow-500/30',
        text: 'text-yellow-700',
    },
    '6': {
        name: 'Cobro automático cancelado',
        code: '6',
        class: 'bg-pink-500/30',
        text: 'text-pink-700',
    },
};

export const STATUS_BOOKING = [
    {
        id: 'Aprobado',
        name: 'Aprobado',
        title: 'Aplicados',
        code: 'applied',
        border: 'border-green-300',
        text: 'text-green-700',
    },
    {
        id: 'Sin procesar',
        name: 'Sin procesar',
        title: 'Sin procesar',
        code: 'pending',
        border: 'border-orange-300',
        text: 'text-orange-700',
    },
    {
        id: 'Declinado',
        name: 'Declinado',
        title: 'Rechazados',
        code: 'rejected',
        border: 'border-red-300',
        text: 'text-red-700',
    },
    {
        id: 'Pendiente de aprobación',
        name: 'Pendiente de aprobación',
        title: 'Programados',
        code: 'programmed',
        border: 'border-primary-300',
        text: 'text-primary-700',
    },
];

export const STATUS_PAY = [
    {
        id: 'Aplicado',
        name: 'Aplicado',
        class: 'bg-green-500/30',
        text: 'text-green-700',
    },
    {
        id: 'Aprobado',
        name: 'Aprobado',
        class: 'bg-green-500/30',
        text: 'text-green-700',
    },
    {
        id: 'Cancelado',
        name: 'Cancelado',
        class: 'bg-red-500/30',
        text: 'text-red-700',
    },
    {
        id: 'Declinado',
        name: 'Declinado',
        class: 'bg-red-500/30',
        text: 'text-red-700',
    },
    {
        id: 'Salida anticipada',
        name: 'Salida anticipada',
        class: 'bg-orange-500/30',
        text: 'text-orange-700',
    },
    {
        id: 'Pendiente de aprobación',
        name: 'Pendiente de aprobación',
        class: 'bg-purple-500/30',
        text: 'text-purple-700',
    },
    {
        id: 'Sin procesar',
        name: 'Sin procesar',
        class: 'bg-orange-500/30',
        text: 'text-orange-700',
    },
    {
        id: 'Pago en proceso',
        name: 'Pago en proceso',
        class: 'bg-yellow-500/30',
        text: 'text-yellow-700',
    },
    {
        id: 'Tarjeta no válida',
        name: 'Tarjeta no válida',
        class: 'bg-pink-500/30',
        text: 'text-pink-700',
    },
    {
        id: 'Rechazado',
        name: 'Rechazado',
        class: 'bg-rose-500/30',
        text: 'text-rose-700',
    },
    {
        id: 'Reembolso parcial',
        name: 'Reembolso parcial',
        class: 'bg-lime-500/30',
        text: 'text-lime-700',
    },
    {
        id: 'Reembolso total',
        name: 'Reembolso total',
        class: 'bg-emerald-500/30',
        text: 'text-emerald-700',
    },
    {
        id: 'Reembolso en proceso',
        name: 'Reembolso en proceso',
        class: 'bg-amber-500/30',
        text: 'text-amber-700',
    },
    {
        id: 'Reembolso rechazado',
        name: 'Reembolso rechazado',
        class: 'bg-red-500/30',
        text: 'text-red-700',
    },
];

export const STATUS_PAY_OBJ = {
    Aplicado: {
        name: 'Aplicado',
        code: '1',
        class: 'bg-green-200/30',
        text: 'text-green-700',
    },
    'Pago aplicado': {
        name: 'Aplicado',
        code: '2',
        class: 'bg-green-200/30',
        text: 'text-green-700',
    },
    Cancelado: {
        name: 'Cancelado',
        code: '3',
        class: 'bg-gray-200/30',
        text: 'text-gray-700',
    },
    'Pago Cancelado': {
        name: 'Cancelado',
        code: '4',
        class: 'bg-red-200/30',
        text: 'text-red-700',
    },
    'Salida anticipada': {
        name: 'Salida anticipada',
        code: '5',
        class: 'bg-orange-200/30',
        text: 'text-orange-700',
    },
    Pendiente: {
        name: 'Pendiente',
        code: '6',
        class: 'bg-purple-200/30',
        text: 'text-purple-700',
    },
    'Pendiente de aprobación': {
        name: 'Pendiente de aprobación',
        code: '7',
        class: 'bg-purple-200/30',
        text: 'text-purple-700',
    },
    'Sin procesar': {
        name: 'Sin procesar',
        code: '8',
        class: 'bg-orange-200/30',
        text: 'text-orange-700',
    },
    'Pendiente de pago': {
        name: 'Pendiente',
        code: '9',
        class: 'bg-purple-200/30',
        text: 'text-purple-700',
    },
    'Pago en proceso': {
        name: 'Pago en proceso',
        code: '10',
        class: 'bg-yellow-200/30',
        text: 'text-yellow-700',
    },
    Rechazado: {
        name: 'Rechazado',
        code: '11',
        class: 'bg-rose-200/30',
        text: 'text-rose-700',
    },
    'Pago rechazado': {
        name: 'Pago rechazado',
        code: '12',
        class: 'bg-rose-200/30',
        text: 'text-rose-700',
    },
    'Tarjeta no válida': {
        name: 'Tarjeta no válida',
        code: '13',
        class: 'bg-pink-200/30',
        text: 'text-pink-700',
    },
    'Reembolso parcial': {
        name: 'Reembolso parcial',
        code: '14',
        class: 'bg-lime-200/30',
        text: 'text-lime-700',
    },
    'Reembolso total': {
        name: 'Reembolso total',
        code: '15',
        class: 'bg-emerald-200/30',
        text: 'text-emerald-700',
    },
    'Reembolso en proceso': {
        name: 'Reembolso en proceso',
        code: '16',
        class: 'bg-amber-200/30',
        text: 'text-amber-700',
    },
    'Reembolso rechazado': {
        name: 'Reembolso rechazado',
        code: '17',
        class: 'bg-red-200/30',
        text: 'text-red-700',
    },
    'Link de pago': {
        name: 'Link de pago',
        code: '18',
        class: 'bg-blue-200',
        text: 'text-blue-700',
    },
    Automatizada: {
        name: 'Automatizada',
        code: '19',
        class: 'bg-green-200',
        text: 'text-green-700',
    },
    'Datáfono virtual': {
        name: 'Datáfono Virtual',
        code: '20',
        class: 'bg-yellow-200',
        text: 'text-yellow-700',
    },
    Programación: {
        name: 'Programación',
        code: '21',
        class: 'bg-orange-200',
        text: 'text-orange-700',
    },
    Aprobado: {
        name: 'Aprobado',
        code: '22',
        class: 'bg-green-200/30',
        text: 'text-green-700',
    },
    Declinado: {
        name: 'Declinado',
        code: '23',
        class: 'bg-red-200/30',
        text: 'text-red-700',
    },
    'En proceso': {
        name: 'En proceso',
        code: '10',
        class: 'bg-yellow-200/30',
        text: 'text-yellow-700',
    },
};

export const MODEL_PAY = [
    {
        id: 'Link de pago',
        name: 'Link de pago',
    },
    {
        id: 'Automatizada',
        name: 'Automatizada',
    },
    {
        id: 'Reembolso',
        name: 'Reembolso',
    },
    {
        id: 'Datáfono virtual',
        name: 'Datáfono virtual',
    },
];
export const PORTAL_LIST = [
    { id: 'Expedia', name: 'Expedia' },
    { id: 'Despegar', name: 'Despegar' },
    { id: 'Booking.com', name: 'Booking' },
    { id: 'Hiperguest', name: 'Hyperguest' },
    { id: 'Hotelbed', name: 'Hotelbed' },
    { id: 'RoomCloud', name: 'Roomcloud' },
    { id: 'Hopper', name: 'Hopper' },
    { id: 'Prices Travel', name: 'Prices Travel' },
    { id: 'Escalabed', name: 'Escalabed' },
    { id: 'TBO', name: 'TBO' },
    { id: 'Roibos', name: 'Roibos' },
    { id: 'siteminder_engine', name: 'Siteminder Engine' },
    { id: 'cloudbeds_engine', name: 'Cloudbeds Engine' },
];

export const PORTAL_CODE = {
    Expedia: {
        src: 'assets/images/portal/expedia.svg',
        code: 'Expedia',
        label: 'Expedia',
    },
    expedia: {
        src: 'assets/images/portal/expedia.svg',
        code: 'expedia',
        label: 'Expedia',
    },
    Despegar: {
        src: 'assets/images/portal/despegar.svg',
        code: 'Despegar',
        label: 'Despegar',
    },
    'Booking.com': {
        src: 'assets/images/portal/booking.svg',
        code: 'Booking.com',
        label: 'Booking.com',
    },
    Hiperguest: {
        src: 'assets/images/portal/HyperGuest.svg',
        code: 'Hiperguest',
        label: 'Hyperguest',
    },
    hyperguest: {
        src: 'assets/images/portal/HyperGuest.svg',
        code: 'hyperguest',
        label: 'Hyperguest',
    },
    Hotelbed: {
        src: 'assets/images/portal/hotelbed.svg',
        code: 'Hotelbed',
        label: 'Hotelbed',
    },
    RoomCloud: {
        src: 'assets/images/portal/roomcloud.png',
        code: 'RoomCloud',
        label: 'Roomcloud',
    },
    Hopper: {
        src: 'assets/images/portal/hopper.svg',
        code: 'Hopper',
        label: 'Hopper',
    },
    'Prices Travel': {
        src: 'assets/images/portal/princeTravel.svg',
        code: 'Prices Travel',
        label: 'Prices Travel',
    },
    Escalabed: {
        src: 'assets/images/portal/Escalabed.png',
        code: 'Escalabed',
        label: 'Escalabed',
    },
    TBO: {
        src: 'assets/images/portal/TBO.png',
        code: 'TBO',
        label: 'TBO',
    },
    Roibos: {
        src: 'assets/images/portal/roibos.png',
        code: 'Roibos',
        label: 'Roibos',
    },
    Roiback: {
        src: 'assets/images/portal/roiback.png',
        code: 'Roiback',
        label: 'Roiback',
    },
    'Siteminder Engine': {
        src: 'assets/images/portal/siteminder.png',
        code: 'siteminder_engine',
        label: 'Siteminder Engine',
    },
    'Cloudbeds Engine': {
        src: 'assets/images/portal/cloudbeds.svg',
        code: 'cloudbeds_engine',
        label: 'Cloudbeds Engine',
    },
};

export const TYPE_KEY = {
    Api_Key: 'Api',
    Session_Token: 'Token',
    Asymmetric_Encryption: 'Cifrado asimétrico',
    Pgp_Encryption: 'Cifrado PGP',
};

export enum ROLES {
    Holding = 'holding',
    Agency = 'agency',
    Hotel = 'hotel',
    HyperAdmin = 'admin',
    Demo = 'demo',
}

export const EXP_MONTH = [
    { id: 1, name: '1' },
    { id: 2, name: '2' },
    { id: 3, name: '3' },
    { id: 4, name: '4' },
    { id: 5, name: '5' },
    { id: 6, name: '6' },
    { id: 7, name: '7' },
    { id: 8, name: '8' },
    { id: 9, name: '9' },
    { id: 10, name: '10' },
    { id: 11, name: '11' },
    { id: 12, name: '12' },
];

export const EXP_YEAR = [
    { id: 2025, name: '2025' },
    { id: 2026, name: '2026' },
    { id: 2027, name: '2027' },
    { id: 2028, name: '2028' },
    { id: 2029, name: '2029' },
    { id: 2030, name: '2030' },
    { id: 2031, name: '2031' },
    { id: 2032, name: '2032' },
    { id: 2033, name: '2033' },
    { id: 2034, name: '2034' },
    { id: 2035, name: '2035' },
    { id: 2036, name: '2036' },
    { id: 2037, name: '2037' },
    { id: 2038, name: '2038' },
    { id: 2039, name: '2039' },
    { id: 2040, name: '2040' },
    { id: 2041, name: '2041' },
    { id: 2042, name: '2042' },
    { id: 2043, name: '2043' },
    { id: 2044, name: '2044' },
];

export const HOURS = [
    { id: 0, name: '00:00' },
    { id: 1, name: '01:00' },
    { id: 2, name: '02:00' },
    { id: 3, name: '03:00' },
    { id: 4, name: '04:00' },
    { id: 5, name: '05:00' },
    { id: 6, name: '06:00' },
    { id: 7, name: '07:00' },
    { id: 8, name: '08:00' },
    { id: 9, name: '09:00' },
    { id: 10, name: '10:00' },
    { id: 11, name: '11:00' },
    { id: 12, name: '12:00' },
    { id: 13, name: '13:00' },
    { id: 14, name: '14:00' },
    { id: 15, name: '15:00' },
    { id: 16, name: '16:00' },
    { id: 17, name: '17:00' },
    { id: 18, name: '18:00' },
    { id: 19, name: '19:00' },
    { id: 20, name: '20:00' },
    { id: 21, name: '21:00' },
    { id: 22, name: '22:00' },
    { id: 23, name: '23:00' },
];

/**
 * @name FILE_MAX_SIZE
 * @description Max file size allowed. 2 MB
 */
export const FILE_MAX_SIZE = 70000000;

/**
 * @name FILE_MAX_SIZE_LABEL
 * @description Max file size allowed. 2 MB
 */
export const FILE_MAX_SIZE_LABEL = '70 MB';

export const encrypt_frontend =
    'LS0tLS1CRUdJTiBQVUJMSUMgS0VZLS0tLS0KTUlJQklqQU5CZ2txaGtpRzl3MEJBUUVGQUFPQ0FROEFNSUlCQ2dLQ0FRRUFyZ05PVno4akZBSk1acDNMWWEwago0RHNVbXdZa0lKNFVNNnQvbjNJaXZWOVNhYUVJUTE5ZkR0YytYQU9weDBIU2xrek02UHkxc1ZrNjYrb2FFWEJHCmk4eUVMOUQ2aWFNSHRaN3hPbEdiUER1dm1UWnZqb0dyeTVyS0hIWjdEckFwWXVyZEx1dHltdkZWeDVCYVRrNGgKdndodTBHZXlMYm1KL2NwbVBSejgrdGVUSzd5aWRvazA1Zm5HT0VMaWJLdVJ6R3lkSDhGOE40cVpnN2EyK1Z3cQp1TWcxM2l0Z3dMMm9rUFFtWWNTOHFac0tWcFJPSDRNTHRMRjdPWGpOZ3lrbitiYzBNdFBHcDhYWkcwL21pRjJLCmN0WEtMRlFoYk5zdjBad1BkSjdhNitWYVg4TzlmQU53aFVxdmpXdXFES2F1LzFJTGJESVNRcHhmMjM3SmtCc0EKZFFJREFRQUIKLS0tLS1FTkQgUFVCTElDIEtFWS0tLS0tCg==';
export const desencrypt_backend =
    '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';
export const codesError: any = {
    'Unrecognized credit card company':
        'Compañía de tarjetas de crédito no reconocida',
    incomplete_cvc: 'CVC incompleto',
    incomplete_date: 'Fecha incompleta',
    date_in_past: 'Fecha en pasadp',
    invalid_expiration_year: 'Año de expiración invalida',
    incomplete_card_number: 'Número de tarjeta incompleto',
    incorrect_card_number: 'Número de tarjeta incorrecto',
};

export const actionsList = {
    edit: { name: 'Editar', icon: MAT_SVG_ICON.EDIT_OUTLINE },
    detail: { name: 'Detalles', icon: MAT_SVG_ICON.EYE_OUTLINE },
    refund: { name: 'Reembolso', icon: 'autorenew' },
    voucher: { name: 'Recibo', icon: 'download' },
    add_voucher: { name: 'Adjuntar comprobante', icon: 'upload_file' },
    transations: { name: 'Transaciones', icon: 'trending_up' },
    report: { name: 'Reporte transacción', icon: 'assignment_returned' },
    delete: { name: 'Eliminar', icon: 'delete' },
    manage_status: { name: 'Gestionar estado', icon: 'adjust' },
    asociate_hotel: { name: 'Hoteles asociados', icon: 'business' },
    manage_policy: { name: 'Gestionar política', icon: 'assignment' },
    manage_user: { name: 'Gestionar usuarios', icon: 'assignment_ind' },
    manage_permission: { name: 'Gestionar permisos', icon: 'build' },
    keys: { name: 'Claves de acceso', icon: 'key' },
    breakdown: { name: 'Desglose', icon: 'view_headline' },
    file: { name: 'Archivar', icon: 'file_copy' },
    link: { name: 'Generar link', icon: 'link' },
    cancel: { name: 'Cancelar cobro', icon: 'cancel_presentation' },
    change_status: { name: 'Cambiar estado', icon: 'low_priority' },
};

export const routeMap: { [key: string]: string } = {
    main: 'Inicio',
    link: 'Link de pago',
    list: 'Lista',
    bookings: 'Automatizados',
    management: 'Creación',
    details: 'Detalles',
    detail: 'Detalles',
    dataphone: 'Terminal Virtual',
    pay: 'Crear Pago',
    'payment-alternative': 'Pagos alternativos',
    transactions: 'Transaciones',
    'hotel/list': 'Lista',
    billing: 'Facturación',
    'bookings-room': 'Reservas',
    payments: 'Pagos',
    summary: 'Resumen',
    'hyper/list': 'Lista',
    'holdings-management': 'Grupo empresarial',
    create: 'Crear',
    holdingDemo: 'Grupo empresarial Demo',
    manegement: 'Gestionar',
    'company-management': 'Razon social',
    edit: 'Editar',
    'agency-management': 'Agencias',
    'hotel-management': 'Propiedades',
    'policy-management': 'Gestión de Politicas',
    register: 'Registro',
    demo: 'Demo',
    status: 'Estado',
    'criterias-management': 'Criterios de políticas',
    'plans-management': 'Planes de Reservas',
    'otas-management': 'Otas',
    'parameterization-management': 'Parametrización',
    'documents/list': 'Lista',
    'documents/create': 'Crear Documento',
    'trm-management': 'TRM',
    'user-management': 'Usuarios',
    'apikey-management': 'Clave de Acceso',
    permissions: 'Permisos',
    'roles-management': 'Roles',
    dashboard: 'Estadisticas',
    balance: 'Balance',
    overview: 'Lista',
    transactionsHyper: 'Transaciones',

    // Agrega aquí el mapeo de todas las rutas de tu aplicación
};

export const methodsAux = [
    {
        name: 'Con Tarjeta de crédito o débito',
        description: 'Ingresas los datos y paga online.',
        code: 'credit-card',
        code2: 'credit-card',
        codeHotel: 'credit_card',
        subItems: false,
        expanded: false,
        icon: MAT_SVG_ICON.CARD_OUTLINE,
    },
    {
        name: 'Desde tu Banco',
        description: 'Paga online desde tu cuenta bancaria.',
        code: 'pse',
        code2: 'pse',
        codeHotel: 'bank_transfer',
        subItems: false,
        expanded: false,
        icon: MAT_SVG_ICON.BUILDING_OUTLINE,
    },
    {
        name: 'En Efectivo',
        description: 'Creas referencia y vas a un punto de pago.',
        code: 'cash',
        code2: 'cash',
        codeHotel: 'cash',
        subItems: false,
        expanded: false,
        icon: MAT_SVG_ICON.CASH_OUTLINE,
    },
    {
        name: 'Con Billetera digital',
        description: 'Accedes a tu billetera y pagas online.',
        code: 'wallet',
        code2: 'wallet',
        codeHotel: 'wallet',
        subItems: false,
        expanded: false,
        icon: MAT_SVG_ICON.WALLET_OUTLINE,
    },
    {
        name: 'Saldo prepagado',
        description: 'Realiza pago con saldo cargado previamente.',
        code: 'preloaded-balance',
        code2: 'preloaded-balance',
        codeHotel: 'preloaded_balance',
        subItems: true,
        expanded: false,
        icon: MAT_SVG_ICON.BILLING_OUTLINE,
    },
];

export const CASH_PAYMENT_IMAGES = {
    corresponsal: '/assets/icons/bancolombia.svg',
    daviplata: '/assets/icons/daviplata.svg',
    efecty_nuvei: '/assets/icons/efecty.svg',
    efecty_monnet: '/assets/icons/efecty.svg',
    efecty_redeban: '/assets/icons/efecty.svg',
    puntored: '/assets/icons/puntored.svg',
    nequi: '/assets/icons/nequi.svg',
    qrbancolombia: '/assets/icons/bancolombia.svg',
    pse: '/assets/icons/pse.svg',
    boton_bancolombia: '/assets/icons/boton_bancolombia.png',
};

export const QUOTAS = [
    { id: 1, name: 1 },
    { id: 2, name: 2 },
    { id: 3, name: 3 },
    { id: 4, name: 4 },
    { id: 5, name: 5 },
    { id: 6, name: 6 },
    { id: 7, name: 7 },
    { id: 8, name: 8 },
    { id: 9, name: 9 },
    { id: 10, name: 10 },
    { id: 11, name: 11 },
    { id: 12, name: 12 },
    { id: 13, name: 13 },
    { id: 14, name: 14 },
    { id: 15, name: 15 },
    { id: 16, name: 16 },
    { id: 17, name: 17 },
    { id: 18, name: 18 },
];

export const PAGINATION: Pagination = {
    limit: '20',
    offset: '0',
};

export const QRHotel = {
    azuan_suites: 'assets/qr/azuan_qr.png',
    ghs_1525: 'assets/qr/1525_qr.png',
    libertg_hotels_spa: 'assets/qr/libertg_qr.png',
    abi_inn: 'assets/qr/abi_inn_qr.png',
    aixo_suites: 'assets/qr/aixo_suites_qr.png',
    avexi_suites: 'assets/qr/avexi_suites_qr.png',
    hotel_axis: 'assets/qr/axis_qr.png',
    bocagrande_ctg: 'assets/qr/bocagrande_ctg_qr.png',
    cannatel: 'assets/qr/cannatel_qr.png',
    casa_belle_luxury_house: 'assets/qr/casa_belle_luxury_house_qr.png',
    casa_botero: 'assets/qr/casa_botero_qr.png',
    hotel_chiniu: 'assets/qr/chiniu_qr.png',
    elan_at_ballena_beach: 'assets/qr/elan_at_ballena_beach_qr.png',
    hotel_exelsior: 'assets/qr/exelsior_qr.png',
    hotel_hukumeizi: 'assets/qr/hukumeizi_qr.png',
    infinity_hotel: 'assets/qr/infinity_qr.png',
    la_playita_isla_fuerte: 'assets/qr/la_playita_isla_fuerte_qr.png',
    madisson_inn: 'assets/qr/madisson_qr.png',
    mandala_belen: 'assets/qr/mandala_belen_qr.png',
    mandala_botero: 'assets/qr/mandala_botero_qr.png',
    mandala_centro: 'assets/qr/mandala_centro_qr.png',
    marina_suites: 'assets/qr/marina_suites_qr.png',
    panorama: 'assets/qr/panorama_qr.png',
    playa_club: 'assets/qr/playa_club_qr.png',
    playa_paraiso: 'assets/qr/playa_paraiso_qr.png',
    qosqo_wasi: 'assets/qr/qosqo_wasi_qr.png',
    rodadero_inn: 'assets/qr/rodadero_inn_qr.png',
    hotel_samakwa: 'assets/qr/samakwa_qr.png',
    hotel_sansiraka: 'assets/qr/sansiraka_qr.png',
    sm_Grand: 'assets/qr/sm_Grand_qr.png',
    terra_biohotel: 'assets/qr/terra_biohotel_qr.png',
    the_Art_hotel: 'assets/qr/the_Art_hotel_qr.png',
    hotel_del_tropico: 'assets/qr/tropico_qr.png',
    windsor_house: 'assets/qr/windsor_house_qr.png',
    z3_hotel: 'assets/qr/z3_hotel_qr.png',
    hotel_zaraya: 'assets/qr/zaraya_qr.png',
    zulita: 'assets/qr/zulita_qr.png',
    bioma_boutique_hotel: 'assets/qr/bioma_qr.png',
    hotel_boquilla_suites: 'assets/qr/hotel_boquilla_qr.png',
    aborigenes_hotel: 'assets/qr/aborigenes_qr.png',
    hotel_villas_de_san_sebastian: 'assets/qr/villas_de_san_sebastian_qr.png',
    hotel_casa_73_deluxe: 'assets/qr/hotel_casa_73_deluxe_qr.png',
    palermo_home: 'assets/qr/Palermo_Home_qr.png',
    albarrada_hotel_boutique: 'assets/qr/Albarrada_hotel_qr.png',
    hotel_porton_bogota: 'assets/qr/Hotel_Porton_Bogota_qr.png',
    hotel_rodadero_dorado: 'assets/qr/Rodadero_Dorado_qr.png',
    hotel_regatta: 'assets/qr/Hotel_Regatta_qr.png',
    hotel_villa_los_candiles: 'assets/qr/Hotel_Villa_Los_Candiles_qr.png',
    in_di_house_of_reggae: 'assets/qr/In_di_house_of_reggae_qr.png',
    hotel_casa_linda_vista: 'assets/qr/Hotel_Casa_linda_vista_qr.png',
    hotel_la_casona_laureles: 'assets/qr/Hotel_La_Casona_Laureles_qr.png',
    sueno_pacifico: 'assets/qr/sueno_pacifico_qr.png',
    colours_oasis_resort: 'assets/qr/colours_oasis_resort_qr.png',
    cabanas_la_laguna_lodge: 'assets/qr/cabanas_la_laguna_lodge_qr.png',
    lares_de_la_70: 'assets/qr/lares_de_la_70_qr.png',
    el_cielo_en_la_tierra: 'assets/qr/el_cielo_en_la_tierra_qr.png',
    malik_hotel_boutique: 'assets/qr/malik_hotel_boutique_qr.png',
    patio_andaluz_hotel_boutique: 'assets/qr/patio_andaluz_hotel_boutique_qr.png',
    nogal_suite_pasto: 'assets/qr/nogal_suite_pasto_qr.png',
    nogal_suite_ipiales: 'assets/qr/nogal_suite_ipiales_qr.png',
    internacional_nogal: 'assets/qr/internacional_nogal_qr.png',
    hotel_bali_poblado: 'assets/qr/hotel_bali_poblado_qr.png'
};
